<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1766652" style="color: #82a339"><b>BUTTERNUT-APPLE SOUP</b></p>
<p class="ext" id="d7e1767152"><b><i>Nothing can match a pureed vegetable and cream soup for texture and this subtly sweet combination of squash and apples just proves the point.</i></b></p>
<p class="h4" id="d7e1768452" style="color: #496210"><b>Prep: 15 minutes Cook: 40 to 45 minutes</b></p>
<p class="ul" id="d7e1768952">2 tablespoons vegetable oil</p>
<p class="ul" id="d7e1769252">1 small onion, chopped</p>
<p class="ul" id="d7e1769552">2 medium butternut squash (1¾ pounds each), <br/> peeled, seeded, and cut into ¾-inch pieces</p>
<p class="ul" id="d7e1771852">¾ pound Golden Delicious apples (2 medium), <br/> peeled, cored, and coarsely chopped</p>
<p class="ul" id="d7e1773352">1 can (14½ ounces) vegetable broth or</p>
<p class="ul" id="d7e1774452">1¾ cups Vegetable Broth</p>
<p class="ul" id="d7e1775652">1½ cups water</p>
<p class="ul" id="d7e1776752">1 teaspoon freshly chopped fresh thyme or</p>
<p class="ul" id="d7e1777052">¼ teaspoon dried thyme</p>
<p class="ul" id="d7e1778052">1 teaspoon salt</p>
<p class="ul" id="d7e1778352">⅛ teaspoon coarsely ground black pepper</p>
<p class="ul" id="d7e1779352">1 cup half-and-half or light cream</p>
<p class="pub" id="d7e1779952" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 4-quart saucepan, heat oil over medium heat. Add onion and cook until tender and golden, about 10 minutes. Stir in squash, apples, broth, water, thyme, salt, and pepper; heat to boiling over high heat. Reduce heat to low; cover and simmer, stirring often, until squash is very tender, 20 to 25 minutes.</p>
<p class="pub" id="d7e1782452"><span style="color: #c15b49"><b>2.</b></span> Spoon one-third of squash mixture into blender; cover, with center part of cover removed to let steam escape, and puree until smooth. Pour puree into bowl. Repeat with remaining mixture.</p>
<p class="pub" id="d7e1784352"><span style="color: #c15b49"><b>3.</b></span> Return puree to saucepan; stir in half-and-half. Heat through over medium heat, stirring occasionally (do not boil). Makes about 9 cups or 8 first-course servings.</p>
<p class="ntx" id="d7e1786452">Each serving: About 175 calories, 3g protein, 28g carbohydrate, 7mg total fat (3mg saturated), 11mg cholesterol, 525mg sodium.</p>
<p class="h4l" id="d7e1789152" style="color: #496210"><b>SPICY CURRIED CARROT SOUP</b></p>
<p class="tx1" id="d7e1789652">Prepare as directed but substitute <b>2 pounds carrots,</b> peeled and cut into 2-inch pieces, for squash. Increase broth to 2 cans. In Step 1, omit thyme and <b>add 2 teaspoons curry powder,</b> and <b>2 teaspoons grated fresh ginger.</b> Omit half-and-half. Makes about 8 cups or 8 first-course servings.</p>
<p class="ser"><img alt="9781618371621_0053_001" src="Images/9781618371621_0053_001.jpg" style="max-width:100%;"/></p>
<p class="cap" id="d7e1793653">Butternut-Apple Soup</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c47_r1.vue?91dfa040